var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_12803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.08105V19.4144",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 4.41504H7.91667C7.14312 4.41504 6.40125 4.72233 5.85427 5.26931C5.30729 5.81629 5 6.55816 5 7.33171C5 8.10525 5.30729 8.84712 5.85427 9.3941C6.40125 9.94108 7.14312 10.2484 7.91667 10.2484H12.0833C12.8569 10.2484 13.5987 10.5557 14.1457 11.1026C14.6927 11.6496 15 12.3915 15 13.165C15 13.9386 14.6927 14.6805 14.1457 15.2274C13.5987 15.7744 12.8569 16.0817 12.0833 16.0817H5",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_12803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.248047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.896739af5d8b5d4eeb6216f1a0e52699.svg";
export { ForwardRef as ReactComponent };